import DashboardLayout from "../../layouts/DashboardLayout";
import MeasureTranslationsCard from "../../components/settings/MeasureTranslationsCard";
import ToolkitTranslationsCard from "../../components/settings/ToolkitTranslationsCard";

// Platform admin → Translations. One translation per language, used by every clinic.
export default function AdminTranslations({ kind }) {
  const toolkit = kind === "toolkit";
  return (
    <DashboardLayout>
      <div className="max-w-5xl mx-auto space-y-4">
        <h1 className="text-2xl font-bold text-secondary-900">{toolkit ? "Toolkit translations" : "Questionnaire translations"}</h1>
        {toolkit ? <ToolkitTranslationsCard /> : <MeasureTranslationsCard />}
      </div>
    </DashboardLayout>
  );
}
